import { useEffect } from "react";

const SITE_NAME = "DocGalaxy Gujarat";
const DEFAULT_TITLE = "GARVI 2.0, Index-2 & E-Stamping | Gujarat";
const DEFAULT_DESC = "Get GARVI 2.0, Index-2, certified copy, e-stamping and rent agreement maker help in Gujarat. Contact DocGalaxy today.";

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => k !== "content" && el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", attrs.content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function Seo({ title, description, type = "website", noindex = false, image, canonicalPath, rawTitle }) {
  useEffect(() => {
    const fullTitle = rawTitle || (title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE);
    const desc = description || DEFAULT_DESC;
    const path = canonicalPath || window.location.pathname;
    const canonical = `${window.location.origin}${path === "/" ? "/" : path.replace(/\/+$/, "")}`;
    const lang = document.documentElement.lang === "gu" ? "gu_IN" : "en_IN";

    document.title = fullTitle;
    upsertMeta('meta[name="description"]', { name: "description", content: desc });
    upsertMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large" });
    upsertLink("canonical", canonical);
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: desc });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: type });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: SITE_NAME });
    upsertMeta('meta[property="og:locale"]', { property: "og:locale", content: lang });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: image || `${window.location.origin}/og-image.png` });
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: desc });
  }, [title, description, type, noindex, image, canonicalPath, rawTitle]);
  return null;
}
